export const ProfilePageSchema = {
  "@context": "https://schema.org",
  "@type": "ProfilePage",
  "mainEntity": {
    "@type": "Person",
    "name": "حمید فروزنده",
    "jobTitle": "مدیر عامل و رئیس هیئت مدیره",
    "image": "https://navatel.ir/_ipx/q_80&s_500x442/img/managers/main.png",
    "url": "https://navatel.ir/managers/",
    "description": "حمید فروزنده مدیر عامل و رئیس هیئت مدیره شرکت شبکه گستران آریاسامانه (نواتل)، کارآفرین و نوآور در حوزه اینترنت، مخابرات و فناوری اطلاعات است. وی مرکز تلفن ابری و مرکز تماس ابری نواتل را به عنوان محصولات دانش بنیان به بازار معرفی کرده است.",
    "worksFor": {
      "@type": "Organization",
      "name": "Navatel",
      "url": "https://navatel.ir/"
    },
    "alumniOf": [
      {
        "@type": "CollegeOrUniversity",
        "name": "دانشگاه شهید بهشتی"
      },
      {
        "@type": "CollegeOrUniversity",
        "name": "دانشگاه منچستر"
      }
    ]
  }
}
